import { createContext } from 'react'
import type { TourStep, TourChapter } from './tour-chapters'

export interface TourContextValue {
  /** The active chapter, or null when no tour is running. */
  activeChapter: TourChapter | null
  /** Current step index within the active chapter, or null. */
  currentStepIndex: number | null
  /** The active step definition, or null. */
  currentStep: TourStep | null
  /** Total steps in the active chapter. */
  totalSteps: number
  /** Set of completed chapter IDs. */
  completedChapters: Set<string>
  /** Whether the user has seen the tour hub at least once. */
  hasSeenHub: boolean
  /** The next chapter in the same group that will auto-start, or null. */
  nextGroupChapter: string | null
  startChapter: (chapterId: string) => void
  nextStep: () => void
  prevStep: () => void
  skipChapter: () => void
  resetTour: () => void
}

export const TourContext = createContext<TourContextValue | null>(null)
